import { makeRequest } from 'utils/requestLogger';

export default (discussion_id, turn_type) => {
    return makeRequest('post', `/api/live_discussions/${discussion_id}/turns`, { turn_type });
};
  


// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/queue/tapIn.js